/**
 * Merges FAQ JSON fragments from collapsible-tabs sections into one FAQPage JSON-LD.
 */
(function () {
  function mergeFaqPageSchema() {
    var fragments = document.querySelectorAll(
      'script[type="application/json"][data-faq-page-fragment]'
    );
    if (!fragments.length) return;

    var mainEntity = [];
    for (var i = 0; i < fragments.length; i++) {
      try {
        var items = JSON.parse(fragments[i].textContent.trim());
        if (!Array.isArray(items)) continue;
        for (var j = 0; j < items.length; j++) {
          mainEntity.push(items[j]);
        }
      } catch (e) {
        /* ignore invalid fragment */
      }
    }
    if (!mainEntity.length) return;

    var ld = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: mainEntity,
    };
    var s = document.createElement('script');
    s.type = 'application/ld+json';
    s.setAttribute('data-faq-page-schema-merged', '');
    s.textContent = JSON.stringify(ld);
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mergeFaqPageSchema);
  } else {
    mergeFaqPageSchema();
  }
})();
